import { S as Swiper } from './swiper-core-Bbvcim4W.js';
import { P as Pagination } from './pagination-B1NmdghC.js';
import { A as A11y } from './a11y-SU9kYSAf.js';

class ProductCardSwiper extends HTMLElement {
  #productCard = this.closest('[data-product-card]');
  #productLink = this.#productCard.querySelector('[data-product-card-url]').href;

  constructor() {
    super();
    this.swiperElement = this.querySelector('[data-swiper]');
  }

  connectedCallback() {
    if (!this.swiperElement) return;

    new Swiper(this.swiperElement, {
      modules: [A11y, Pagination],
      slidesPerView: 1,
      threshold: 10,
      preventClicks: true,
      preventClicksPropagation: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });

    this.addEventListener('click', (event) => {
      window.location.href = this.#productLink;
    });
  }
}

if (!customElements.get('product-card-swiper')) customElements.define('product-card-swiper', ProductCardSwiper);
